import { Col, Form, Row } from 'react-bootstrap';
import type { RecommendationEnvironmentFormValue } from '@/pages/recommendation-lab/environment';

interface RecommendationEnvironmentFormProps {
  value: RecommendationEnvironmentFormValue;
  onChange: (_value: RecommendationEnvironmentFormValue) => void;
}

export function RecommendationEnvironmentForm({ value, onChange }: RecommendationEnvironmentFormProps) {
  const update = <Key extends keyof RecommendationEnvironmentFormValue>(
    key: Key,
    nextValue: RecommendationEnvironmentFormValue[Key],
  ) => onChange({ ...value, [key]: nextValue });

  return (
    <Row className="g-2">
      <Col md={4}>
        <Form.Label className="small mb-1">Temperature °C</Form.Label>
        <Form.Control
          size="sm"
          type="number"
          aria-label="Temperature (°C)"
          min={-100}
          max={100}
          step="0.1"
          value={value.temperatureC}
          onChange={(event) => update('temperatureC', event.target.value)}
        />
      </Col>
      <Col md={4}>
        <Form.Label className="small mb-1">Humidity %</Form.Label>
        <Form.Control
          size="sm"
          type="number"
          aria-label="Humidity (%)"
          min={0}
          max={100}
          step="1"
          value={value.humidityPercent}
          onChange={(event) => update('humidityPercent', event.target.value)}
        />
      </Col>
      <Col md={4}>
        <Form.Label className="small mb-1">UV index</Form.Label>
        <Form.Control
          size="sm"
          type="number"
          aria-label="UV index"
          min={0}
          max={20}
          step="0.1"
          value={value.uvIndex}
          onChange={(event) => update('uvIndex', event.target.value)}
        />
      </Col>
      <Col md={6}>
        <Form.Label className="small mb-1">Season</Form.Label>
        <Form.Select
          size="sm"
          aria-label="Season"
          value={value.season}
          onChange={(event) => update('season', event.target.value as RecommendationEnvironmentFormValue['season'])}
        >
          <option value="">Unavailable</option>
          <option value="spring">Spring</option>
          <option value="summer">Summer</option>
          <option value="autumn">Autumn</option>
          <option value="winter">Winter</option>
        </Form.Select>
      </Col>
      <Col md={6}>
        <Form.Label className="small mb-1">U.S. AQI</Form.Label>
        <Form.Control
          size="sm"
          type="number"
          aria-label="U.S. AQI"
          min={0}
          max={500}
          step="1"
          value={value.airQualityIndex}
          onChange={(event) => update('airQualityIndex', event.target.value)}
        />
      </Col>
      <Col md={12}>
        <div className="small text-muted">
          Production derives this snapshot from the saved location. Recommendation logic uses the U.S. AQI category;
          particulate measurements are not separate customer inputs.
        </div>
      </Col>
    </Row>
  );
}
